import { API } from "../../backend";

export const getAllCreators = () => {
  return fetch(`${API}/creator/getall`, {
    method: "GET",
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => console.log(err));
};

// user profile update

export const addProfileImage = (form, userId) => {
  console.log(form, userId, "hedybehdbehdb");
  return fetch(`${API}/user/upadteUserProfile/${userId}`, {
    method: "POST",
    body: form,
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => {
      console.log(err);
    });
};
